import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  page: {
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    marginTop: 10,
  },
  title: {
    fontSize: 16,
    fontWeight: 700,
  },
  subtitle: {
    fontSize: 9,
    color: '#4b5563',
  },
  filters: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 6,
  },
  filterBox: {
    border: '1px solid #d1d5db',
    borderRadius: 4,
    padding: 6,
    minWidth: '31%',
  },
  filterLabel: {
    fontSize: 8,
    color: '#6b7280',
    marginBottom: 2,
  },
  filterValue: {
    fontSize: 9,
    fontWeight: 600,
  },
  summaryGrid: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 6,
  },
  summaryCard: {
    width: '31%',
    border: '1px solid #dbeafe',
    backgroundColor: '#eff6ff',
    borderRadius: 4,
    padding: 8,
  },
  summaryLabel: {
    fontSize: 8,
    color: '#1d4ed8',
    marginBottom: 2,
  },
  summaryValue: {
    fontSize: 10,
    fontWeight: 700,
  },
  table: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #d1d5db',
    borderBottom: 'none',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    borderBottom: '1px solid #d1d5db',
  },
  rowAlt: {
    backgroundColor: '#f9fafb',
  },
  headerRow: {
    backgroundColor: '#1e40af',
  },
  cell: {
    flex: 1,
    padding: 6,
    fontSize: 8,
    color: '#111827',
  },
  headerCell: {
    color: '#ffffff',
    fontWeight: 700,
  },
  footer: {
    fontSize: 8,
    color: '#6b7280',
    textAlign: 'right',
    marginTop: 8,
  },
});
